// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"304df09b","88":"349b592d","153":"c862e9a6","704":"08d49eab","755":"769f8547","774":"6415c182","805":"c3d46c58","868":"84f9ff08","941":"97a59715"}[chunkId] + ".chunk.js";
};